<template>
    <section id="especial" class="parallax-section">

        <!-- <img class="top" :src="onda" alt=""> -->
        <div class="informacoes">
            <h2>Especial 10 anos de<br>Samba Maníacos</h2>
            <div>
                <div class="atracao">
                    <p class="titulo"><b>Atrações confirmadas</b></p>
                    <ul>
                        <li>João Sabiá</li>
                        <li>Banda Milênio</li>
                        <li>Banda Expresso Musical</li>
                        <li>Grupo Chega Mais</li>
                    </ul>
                    <!-- <p>João Sabiá, Banda Milênio, Banda Expresso Musical, Grupo Chega Mais</p> -->
                </div>
                <div class="atracao">
                    <p class="titulo"><b>Convidados especiais</b></p>
                    <ul>
                        <li>Marquinhos Copacabana e Karla</li>
                        <li>Luana Bandeira</li>
                        <li>Mayombe Masai</li>
                        <li>G’leu Cambria</li>
                    </ul>
                    <!-- <p>Marquinhos Copacabana e Karla, Luana Bandeira, Mayombe Masai, G’leu Cambria</p> -->
                </div>
            </div>
        </div>
        <!-- <img class="bottom" :src="onda" alt=""> -->

        <div class="parallax-child-section">
            <section class="fw-main-row" :style="{ 'background-image': 'url(' + background + ')' }">
            </section>
        </div>
    </section>
</template>

<script>
import ImgBackground from '@/assets/img/home/sambamaniacos-background.jpg'
// import ImgBackground from '@/assets/img/home/parallax/foto-panoramica-riodejaneiro.jpg'

export default {
    name: 'Parallax',
    data () {
        return {
            background: ImgBackground
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/_mixin"
    $height-container: 600px
    $height-container-mobile: 900px
    #especial
        // margin: 100px 0
        // SVG
        position: relative
        display: flex
        align-items: center
        justify-content: center
        @include device(mobile)
            &
                width: 100vw
                height: $height-container-mobile
        .informacoes
            position: absolute
            left: 0
            right: 0
            top: 0
            bottom: 0
            display: flex
            align-items: center
            justify-content: center
            flex-direction: column
            z-index: 2
            box-shadow: inset 0px 0px 30px rgb(0, 0, 0)
            h2
                margin-bottom: 50px
                color: white
                text-align: center
                text-shadow: 0px 0px 7px black

            ul
                padding: 0
                margin: 0
                li
                    list-style-type: none
            > div
                display: flex
                @include device(mobile)
                    &
                        flex-direction: column
                        align-items: center
                .atracao
                    background-color: white
                    padding: 40px
                    margin: 5px
                    width: 350px
                    height: 260px
                    border-radius: 5px
                    display: flex
                    flex-direction: column
                    align-items: center
                    justify-content: center
                    @include device(mobile)
                        &
                            width: 90%
                            &:first-of-type
                                margin-bottom: 20px
                    p, li
                        color: black
                        text-align: center
                    .titulo
                        font-size: 20px

        .parallax-child-section
            width: 100%
            height: $height-container
            @include device(mobile)
                &
                    clip: rect(0,auto,auto,0)
                    position: absolute
                    top: 0
                    left: 0
                    height: $height-container-mobile
            .fw-main-row
                background-position: center center
                background-repeat: no-repeat
                background-size: cover
                height: $height-container
                width: 100%
                background-attachment: fixed
                padding: 0rem
                @include device(mobile)
                    &
                        position: fixed
                        display: block
                        top: 0
                        left: 0
                        height: 100%!important
                        transform: translateZ(0)
                        will-change: transform
                        z-index: 1
                        background-attachment: scroll!important

    #parallax
        img
            z-index: 2
            position: absolute
            &.top
                top: -1px
                transform: rotate(180deg)
            &.bottom
                bottom: -1px

</style>
